// Configuration des étapes du tutoriel
// Chaque étape définit un élément cible, un message et une position pour la bulle d'aide

export const tutorialStepsDesktop = [
    {
        id: 'welcome',
        target: null, // Pas de cible spécifique, message centré
        title: 'Bienvenue dans GeoPolitikIA !',
        description: 'Ce tutoriel va vous guider à travers les fonctionnalités principales du jeu. Vous pouvez le passer à tout moment en cliquant sur "Passer".',
        position: 'center',
        highlight: false
    },
    {
        id: 'left-panel-stats',
        target: '.left-panel',
        title: 'Statistiques de votre pays',
        description: 'Ici vous pouvez voir toutes les statistiques de votre pays : économie, militaire, technologie, population, etc.',
        position: 'right',
        highlight: true
    },
    {
        id: 'left-panel-investments',
        target: '.investment-section',
        title: 'Investissements',
        description: 'Utilisez ces boutons 🤌 pour investir dans différents secteurs de votre pays. Chaque investissement a un impact sur vos statistiques.',
        position: 'right',
        highlight: true
    },
    {
        id: 'map',
        target: '.carte-container',
        title: 'Carte du monde',
        description: 'La carte affiche vos territoires et ceux des autres pays. Cliquez sur un pays pour interagir avec lui (défense, guerre).',
        position: 'top',
        highlight: true
    },
    {
        id: 'chat',
        target: '.right-panel',
        title: 'Conseiller IA',
        description: 'Votre conseiller IA vous aide à prendre des décisions. Posez-lui des questions ou demandez des conseils stratégiques.',
        position: 'left',
        highlight: true
    },
    {
        id: 'validate',
        target: '.validate-button',
        title: 'Validation du tour',
        description: 'Une fois vos actions choisies, cliquez ici pour valider votre tour. L\'IA générera alors les événements du tour suivant.',
        position: 'top',
        highlight: true
    },
    {
        id: 'newspaper',
        target: '.newspaper-icon',
        title: 'Journal des nouvelles',
        description: 'Consultez les actualités du monde et l\'historique des événements passés.',
        position: 'bottom',
        highlight: true
    },
    {
        id: 'end',
        target: null,
        title: 'Vous êtes prêt !',
        description: 'Vous connaissez maintenant les bases de GeoPolitikIA. Bonne chance dans votre conquête géopolitique !',
        position: 'center',
        highlight: false
    }
];

export const tutorialStepsMobile = [
    {
        id: 'welcome',
        target: null,
        title: 'Bienvenue dans GeoPolitikIA !',
        description: 'Ce tutoriel va vous guider à travers l\'interface mobile. Vous pouvez le passer à tout moment.',
        position: 'center',
        highlight: false,
        forceView: null
    },
    {
        id: 'footer-nav',
        target: '.footer-mobile',
        title: 'Navigation',
        description: 'Utilisez ces onglets pour naviguer entre les différentes vues : Carte, Chat, Données et Actualités.',
        position: 'top',
        highlight: true,
        forceView: null
    },
    {
        id: 'map-view',
        target: '[data-view="map"]',
        title: 'Vue Carte',
        description: 'La carte affiche vos territoires. Appuyez sur un pays pour interagir avec lui. Vous pouvez décider de les attaquer ou de défendre face à une menace.',
        position: 'top',
        highlight: true,
        forceView: 'map'
    },
    {
        id: 'chat-view',
        target: '[data-view="chat"]',
        title: 'Vue Chat',
        description: 'Discutez avec votre conseiller IA pour obtenir des conseils stratégiques.',
        position: 'top',
        highlight: true,
        forceView: 'chat'
    },
    {
        id: 'data-view',
        target: '[data-view="data"]',
        title: 'Vue Données',
        description: 'Consultez vos statistiques et effectuez des investissements dans différents secteurs. 🤌',
        position: 'top',
        highlight: true,
        forceView: 'data'
    },
    {
        id: 'news-view',
        target: '[data-view="news"]',
        title: 'Vue Actualités',
        description: 'Lisez les nouvelles du monde et l\'historique des événements.',
        position: 'top',
        highlight: true,
        forceView: 'news'
    },
    {
        id: 'end',
        target: null,
        title: 'Vous êtes prêt !',
        description: 'Vous connaissez maintenant l\'interface mobile. Bonne partie !',
        position: 'center',
        highlight: false,
        forceView: null
    }
];
